// IMPORTANT: THIS FILE IS AUTO GENERATED AND OVERWRITTEN ON BUILD!
/* tslint:disable */
export const GITVERSION = {
  "dirty": true,
  "raw": "12.13.0-3-g9a2fa0b80-dirty",
  "hash": "g9a2fa0b80",
  "distance": 3,
  "tag": "12.13.0",
  "semver": {
    "options": {
      "loose": false,
      "includePrerelease": false
    },
    "loose": false,
    "raw": "12.13.0",
    "major": 12,
    "minor": 13,
    "patch": 0,
    "prerelease": [],
    "build": [],
    "version": "12.13.0"
  },
  "suffix": "3-g9a2fa0b80-dirty",
  "semverString": "12.13.0+3.g9a2fa0b80"
};
export const DATESTAMP = '2024-01-30 14:38:46';
/* tslint:enable */
